// call.actions.js
import { callConstants as T } from './constants';
import { callService, refreshCallsAuth } from '../calls';
import { unlockAudio } from '../utils/audioUnlock';

const createCallId = () => {
    try {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    } catch (_error) { }

    try {
        const bytes = new Uint8Array(16);
        window.crypto?.getRandomValues?.(bytes);
        const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, '0')).join('');
        if (hex) return `call-${hex}`;
    } catch (_error) { }

    return `call-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
};

let guardUntil = 0;

const setMeId = (user) => {
    const id = user?._id || user?.id || null;

    if (id) {
        window.__ME_ID__ = String(id);
    }

    return id;
};

export const startCall = ({ to, video = false, chatId = null }) => async (dispatch, getState) => {
    const me = getState().auth?.user;
    const status = getState().call?.status;
    const now = Date.now();

    const meId = me?._id || me?.id || null;

    if (!meId) {
        dispatch({ type: T.ERROR, error: 'Нет пользователя' });
        return;
    }

    if (!to) {
        dispatch({ type: T.ERROR, error: 'Не выбран собеседник' });
        return;
    }

    if (now < guardUntil) return;
    if (status && status !== 'idle') return;

    guardUntil = now + 1200;

    const myId = setMeId(me) || meId;
    const callId = createCallId();
    const mode = video ? 'video' : 'audio';

    refreshCallsAuth();

    dispatch({
        type: T.INVITE,
        callId,
        peerId: to,
        mode,
        chatId,
    });

    try {
        await unlockAudio().catch(() => { });

        await callService.start({
            callId,
            from: myId,
            to,
            video,
            chatId,
        });
    } catch (error) {
        const message = error?.name === 'NotAllowedError'
            ? 'Разрешите доступ к микрофону/камере в браузере'
            : error?.message || 'Ошибка старта звонка';

        dispatch({ type: T.ERROR, error: message });
    }
};

export const acceptCall = () => async (dispatch, getState) => {
    const state = getState().call;
    const me = getState().auth?.user;
    const myId = setMeId(me);

    if (!state?.callId || !state?.peerId || !myId) return;

    refreshCallsAuth();

    try {
        await unlockAudio();

        dispatch({
            type: T.CONNECTING,
        });

        await callService.accept({
            callId: state.callId,
            from: state.peerId,
            to: myId,
            video: state.mode === 'video',
        });
    } catch (error) {
        dispatch({
            type: T.ERROR,
            error: error?.message || 'Ошибка принятия звонка',
        });
    }
};

export const rejectCall = () => async (dispatch, getState) => {
    const state = getState().call;
    const me = getState().auth?.user;
    const myId = setMeId(me);

    if (!state?.callId) return;

    try {
        callService.reject({
            callId: state.callId,
            from: state.peerId,
            to: myId,
        });
    } catch (_error) { }

    dispatch({ type: T.ENDED });
};

export const hangup = (reason = 'ended') => async (dispatch, getState) => {
    const me = getState().auth?.user;
    const myId = setMeId(me);

    try {
        callService.hangup(reason, myId || null);
    } catch (_error) { }

    dispatch({ type: T.ENDED });
};

export const toggleMic = () => (dispatch) => {
    const enabled = callService.toggleMute();

    dispatch({
        type: T.TOGGLE_MIC,
        enabled,
    });
};

export const toggleCam = () => (dispatch) => {
    const enabled = callService.toggleVideo();

    dispatch({
        type: T.TOGGLE_CAM,
        enabled,
    });
};

export const minimizeCallUI = () => ({ type: T.MINIMIZE });

export const restoreCallUI = () => ({ type: T.RESTORE });

export const reportQuality = (level) => () => {
    callService.reportQuality(level);
};
